import qs from 'query-string'

export const shareFacebook = ({ url, description }: { url?: string; description?: string }) => {
  return qs.stringifyUrl({
    url: 'https://facebook.com/sharer.php',
    query: { u: url, description },
  })
}

export const shareVk = ({ url }: { url?: string }) => {
  return qs.stringifyUrl({
    url: 'https://vk.com/share.php',
    query: { url },
  })
}

export const shareTwitter = ({ url }: { url?: string }) => {
  return qs.stringifyUrl({
    url: 'https://twitter.com/share',
    query: { url },
  })
}

export const shareOdnoklassniki = ({ url, title, imageUrl }: { url?: string; title?: string; imageUrl?: string }) => {
  return qs.stringifyUrl({
    url: 'https://connect.ok.ru/offer',
    query: { url, title, imageUrl },
  })
}

export const shareTelegram = ({ url, text }: { url?: string; text?: string }) => {
  return qs.stringifyUrl({
    url: 'https://telegram.me/share/url',
    query: { url, text },
  })
}

export const shareWhatsApp = ({ text }: { text?: string }) => {
  return qs.stringifyUrl({
    url: 'https://wa.me',
    query: { text },
  })
}
